export default {
  productionRequestUrl: "https://devapi2.app.zb2.gr/v1",
  devRequestUrl: "https://devapi2.app.zb2.gr/v1",
  tokenTypeBearer: false, // type of the Auth token is bearer
  API_KEY: "string",
  ID: "id", //id or _id
  licenceID: "string", // the id to take the activated modules,
  image_field_name: "image", // το ονομα που εχει το πεδιο με τις εικονες στο project
};
